import { EmailVerificationScreenComponent } from './components/email-verification-screen/email-verification-screen.component';
import { EmailVerificationVerificationCompleteComponent } from './components/email-verification-screen/email-verification-verification-complete/email-verification-verification-complete.component';
import { EmailVerificationVerificationNeededComponent } from './components/email-verification-screen/email-verification-verification-needed/email-verification-verification-needed.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { NewPasswordComponent } from './components/new-password/new-password.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginService } from './services/login.service';
import { TwoFactorModule } from '../../shared/modules/two-factor/two-factor.module';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PplButtonModule } from '@ppl/ui/button';
import { PplCheckboxModule } from '@ppl/ui/checkbox';
import { PplFormModule } from '@ppl/ui/form';
import { PplIconModule } from '@ppl/ui/icon';
import { PplInputModule } from '@ppl/ui/input';
import { PplLoadingModule } from '@ppl/ui/loading';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    PplIconModule,
    PplLoadingModule,
    PplInputModule,
    PplFormModule,
    PplButtonModule,
    PplCheckboxModule,
    SharedModule,
    TwoFactorModule
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    WelcomeScreenComponent,
    NewPasswordComponent,
    EmailVerificationScreenComponent,
    EmailVerificationVerificationNeededComponent,
    EmailVerificationVerificationCompleteComponent
  ],
  providers: [
    LoginService
  ]
})
export class LoginModule { }
